import { render, staticRenderFns } from "./sustainability.vue?vue&type=template&id=a80745de"
import script from "./sustainability.vue?vue&type=script&lang=ts"
export * from "./sustainability.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports